"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityQueue = void 0;
const heap_1 = require("@datastructures-js/heap");
const priorityQueue_helpers_1 = require("./priorityQueue.helpers");
class PriorityQueue {
    constructor() {
        this._heap = new heap_1.CustomHeap(priorityQueue_helpers_1.compareQueue);
    }
    /**
     * Gets the total size of the queue
     * @public
     * @return { number }
     */
    size() {
        return this._heap.size();
    }
    /**
     * Check to see if the queue is empty
     * @public
     * @return { boolean }
     */
    isEmpty() {
        return this._heap.isEmpty();
    }
    /**
     * Adds an Event to the current queue
     * @public
     * @param { any } Queue item
     * @param { (string|number)[] } Array of values to order the priority queue by a simple greater than / less than equation will take place.
     * @return
     */
    enqueue(item, priority) {
        this._heap.insert({ item, priority });
        return this;
    }
    /**
     * Returns the oldest event in the queue
     * @public
     * @return { any }
     */
    front() {
        if (this.isEmpty())
            return null;
        return this._heap.root().item;
    }
    /**
     * Returns the latest event in the queue
     * @public
     * @return { any }
     */
    back() {
        if (this.isEmpty())
            return null;
        return this._heap.leaf().item;
    }
    /**
     * Returns a sorted array of EventType objects from oldest to latest
     * @public
     * @return { any }
     */
    toArray() {
        if (this.isEmpty())
            return [];
        const sortedQueue = this._heap.clone().sort().reverse();
        const filteredQueue = sortedQueue.map((item) => item.item);
        return filteredQueue;
    }
    /**
     * Removes and returns the oldest event in the queue.
     * @public
     * @return { any }
     */
    dequeue() {
        if (this.isEmpty())
            return null;
        return this._heap.extractRoot().item;
    }
    /**
     * Clears the queue
     * @public
     */
    clear() {
        this._heap.clear();
    }
}
exports.PriorityQueue = PriorityQueue;
